export function updateDrill(col, row, drillDown, drillUp, table) {
    const headerType = table.getCellLocation(col, row);
    let x = 0, y = 0, visible = !1;
    "columnHeader" === headerType ? (x = table.getColsWidth(0, table.rowHeaderLevelCount - 1) - (0 === table.frozenColCount ? table.scrollLeft : 0), 
    y = table.getRowsHeight(0, row - 1) + table.getRowHeight(row) / 2, visible = !0) : "rowHeader" === headerType && (y = table.getRowsHeight(0, table.columnHeaderLevelCount - 1), 
    x = table.getColsWidth(0, col - 1) + table.getColWidth(col) / 2, visible = !0), 
    table.scenegraph.updateDrill(visible, x, y, drillDown, drillUp);
}
//# sourceMappingURL=index.js.map
